export const SkeletonHtml = `
<div class="studio-vo-demo-styling">
  <div class="flex justify-center @container">
    <div
      class="font-ABCDiatype text-glass-800 relative flex w-full max-w-[900px] flex-col gap-4 rounded-[32px] bg-white p-4 @sm:p-6"
      data-testid="voice-demo">
      <div
        class="flex flex-wrap items-center justify-between gap-4 @md:items-start">
        <div class="flex w-full justify-between gap-2 @sm:w-auto">
          <div class="relative w-full">
            <div class="h-[50px] min-w-[260px] animate-pulse rounded-2xl bg-[#F5F5FA]"></div>
          
          </div>
        </div>
        <div class="flex w-full gap-2 @sm:w-auto">
          <button
            aria-label="play"
            class="order-0 flex w-full min-w-[133px] cursor-pointer items-center justify-center gap-1 rounded-2xl bg-[#2F43FA] px-4 py-3 text-[1rem] text-white transition-all hover:bg-[#0415DE] @sm:order-1 @md:w-auto"
            data-testid="voice-demo-button">
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              class="min-w-6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15.334 11.4436C16.4451 10.8021 16.4451 9.19838 15.334 8.55688L7.83398 4.22675C6.72287 3.58525 5.33398 4.38713 5.33398 5.67013V14.3304C5.33398 15.6134 6.72287 16.4153 7.83399 15.7738L15.334 11.4436Z"
                fill="white"></path>
            </svg>
            Play</button
          ><button
            class="flex h-12 cursor-pointer items-center justify-center gap-2 rounded-[16px] border-[1px] border-[#E9EAF0] px-4 py-3 hover:bg-[#E9EAF0]">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7.36334 9.41058L9.27409 11.3213L9.27409 2.49984C9.27409 2.0396 9.64718 1.6665 10.1074 1.6665C10.5677 1.6665 10.9408 2.0396 10.9408 2.49984L10.9408 11.3213L12.8515 9.41058C13.1769 9.08514 13.7046 9.08514 14.03 9.41058C14.3554 9.73602 14.3554 10.2637 14.03 10.5891L10.6967 13.9224C10.3712 14.2479 9.8436 14.2479 9.51817 13.9224L6.18483 10.5891C5.8594 10.2637 5.8594 9.73602 6.18483 9.41058C6.51027 9.08515 7.03791 9.08514 7.36334 9.41058Z"
                fill="black"></path>
              <path
                d="M2.60742 12.4998C2.60742 12.0396 2.98052 11.6665 3.44075 11.6665C3.90099 11.6665 4.27409 12.0396 4.27409 12.4998V15.3675C4.27409 15.7635 4.54422 16.0825 4.89546 16.1498C8.49012 16.8387 11.7247 16.8387 15.3194 16.1498C15.6706 16.0825 15.9408 15.7635 15.9408 15.3675L15.9408 12.4998C15.9408 12.0396 16.3139 11.6665 16.7741 11.6665C17.2343 11.6665 17.6074 12.0396 17.6074 12.4998V15.3675C17.6074 16.5243 16.8069 17.5617 15.6331 17.7867C11.8312 18.5153 8.38367 18.5153 4.58175 17.7867C3.40792 17.5617 2.60742 16.5243 2.60742 15.3675V12.4998Z"
                fill="black"></path>
            </svg>
            <div class="hidden @sm:block">Download</div>
          </button>
        </div>
      </div>
      <div class="mx-[-16px] h-[1px] bg-[#F5F5FA] @sm:mx-[-24px] hidden @sm:block"></div>
      <div class="flex flex-col @lg:flex-row @lg:gap-4">
        <div class="_textAreaWrapper_88osd_1 flex-1 xl:w-11/12 mb-2">
          <div class="h-[150px] w-full animate-pulse @sm:h-[250px]">
            <div class="space-y-3">
              <div class="h-6 w-[96%] rounded bg-[#F5F5FA]"></div>
              <div class="h-6 w-[92%] rounded bg-[#F5F5FA]"></div>
              <div class="hidden h-6 w-[98%] rounded bg-[#F5F5FA] @sm:block"></div>
              <div class="hidden h-6 w-[88%] rounded bg-[#F5F5FA] @sm:block"></div>
              <div class="hidden h-6 w-[75%] rounded bg-[#F5F5FA] @sm:block"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex items-start gap-2 @md:mx-0 @lg:mx-0 @lg:items-center">
        <div class="relative py-1">
          <button
            class="flex cursor-pointer items-center gap-2 rounded-2xl bg-[#F5F5FA] px-[16px] py-[14px] leading-5 hover:border-[#e4eaf1] hover:bg-[#e4eaf1]">
            <div class="text-[1rem]"><span class="-p-2 h-1">🇺🇸</span></div>
            <div class="text-[1rem]">English</div>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="shrink-0">
              <path
                d="M13 6L8 11L3 6"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"></path>
            </svg>
          </button>
        </div>
        <div class="h-[22px] w-[1px] self-center bg-[#F5F5FA]"></div>
        <div class="flex w-full min-w-0 flex-1 items-center @lg:gap-1">
          <div class="relative min-w-0 flex-1">
            <div class="overflow-x-scroll py-1 pl-1 no-scrollbar">
              <div class="flex gap-2 leading-none">
                <div class="h-[48px] w-[120px] animate-pulse rounded-2xl bg-[#F5F5FA] @sm:w-[140px]"></div>
                <div class="h-[48px] w-[120px] animate-pulse rounded-2xl bg-[#F5F5FA] @sm:w-[140px]"></div>
                <div class="h-[48px] w-[120px] animate-pulse rounded-2xl bg-[#F5F5FA] @sm:w-[140px] hidden @sm:block"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
